import config, { company } from '../config';

export default function getRouteParams({ locale = '', uuid: companyUuid = '' }, dateParams) {
  return {
    dataFormat: config.dataFormat,
    dataShrink: config.dataShrink,
    language: {
      default: locale || company.locale,
    },
    params: {
      delivery_platform: config.delivery_platform,
      company_uuid: companyUuid || company.uuid,
      ...dateParams,
    },
  };
}
